define((require) => {
    "use strict";

    const ReactBridge               = require("backbone.react-bridge");
    const template                  = require("ui/editor/email/CopyEmailButtonView.tpl");
    const AbstractEmailButtonView   = require("ui/editor/email/AbstractEmailButtonView");
    const NotificationBar           = require("editor/ui/notificationbar/NotificationBar");
    const CopyKlaviyoEmail          = require("ui/editor/email/CopyKlaviyoEmail").default;
    const CopySfmcEmail             = require("ui/editor/email/CopySfmcEmail").default;

    /**
     * Component representing the Copy Email button for the <tt>EditorPreviewMenu</tt>.
     *
     * @cfg {experienceModel} model The current experience model.
     * @cfg {viewModel} model The current view model.
     *
     * @see EditorPreviewMenu
     *
     * @class CopyEmailButtonView
     */
    return AbstractEmailButtonView.extend({
        className: "email-button-container",

        template,

        events: {
            "click @ui.emailBtnDefault": "_processCopyEmailCodeDefault",
            "click @ui.emailBtnOmetria": "_processCopyEmailCodeOmetria",
            "click @ui.emailBtnKlaviyo": "_displayKlaviyoPopup",
            "click @ui.emailBtnSFMC": "_displaySfmcPopup"
        },
        regions: {
            popupContainer: ".email-client-popup"
        },

        initialize() {
            this.__super();
            this.tooltips.DEFAULT = "Click this button to copy Email code and paste it into your ESP.\n\nTo insure you get the most up to date version of your email, remember to <b>push all your changes</b> before hitting \"Copy Email Code\"";
            this.tooltips.OVERLAPPED_WIDGETS = "You have overlapping interactive elements on your experience (highlighted on the canvas for you). Please separate them to be able to Copy Email Code.";
            this.tooltips.NOT_PUSHED = "Push your experience to be able to copy your email code";
        },

        _processCopyEmailCode(espName, userHTML = "") {
            if (this.ui.emailBtn.hasClass("disabled")) {
                return;
            }
            NotificationBar.close();
            const id = NotificationBar.open("Building email... Please wait");
            const scenes = this.experienceModel.get("scenes");
            scenes.trigger("getEmailActionWidgetsBoundingBoxes", (widgetBoxes)=>{
                this.model.fetch({widgets: widgetBoxes, espName: espName, userHTML: userHTML}).then((model)=>{
                    const errFallback = () => {
                        NotificationBar.close({id, clear: "self"});
                        NotificationBar.error("We couldn't copy email code. Please try again.");
                    };
                    try {
                        let tableHTML = model.get("tableHTML");
                        if ((espName === "klaviyo" || espName === "sfmc") && (!tableHTML.html_code) && (tableHTML.detail.message)) {
                            NotificationBar.close({id, clear: "self"});
                            NotificationBar.error(tableHTML.detail.message);
                            return;
                        } else if ((espName === "klaviyo" || espName === "sfmc") && (tableHTML.html_code)) {
                            tableHTML = tableHTML.html_code;
                        }
                        if (!tableHTML) {
                            errFallback();
                            return;
                        }
                        navigator.clipboard.writeText(tableHTML)
                            .then(()=>{
                                NotificationBar.close({id, clear: "self"});
                                return model.get("sizeWarning")
                                    ? NotificationBar.error("Warning: You have successfully copied email code to your clipboard but your email is larger than 102KB so it will not render properly in Gmail client.")
                                    : NotificationBar.open("You have successfully copied email code to your clipboard. Email Size: " + model.get("emailSize") + "KB", {closeDelay: 5000});
                            })
                            .catch(errFallback);
                    } catch (e) {
                        errFallback();
                    }
                });
            });
        },

        _displayKlaviyoPopup() {
            const copyemailKlaviyo = ReactBridge.viewFromComponent(CopyKlaviyoEmail, {
                props: {show: true, submitCallback: this._processCopyEmailCodeKlaviyo.bind(this)}
            });
            this.popupContainer.show(copyemailKlaviyo);
        },

        _displaySfmcPopup() {
            const copyemailSfmc = ReactBridge.viewFromComponent(CopySfmcEmail, {
                props: {show: true, submitCallback: this._processCopyEmailCodeSFMC.bind(this)}
            });
            this.popupContainer.show(copyemailSfmc);
        },

        _processCopyEmailCodeKlaviyo(userHTML) {
            this._processCopyEmailCode("klaviyo", userHTML);
        },

        _processCopyEmailCodeOmetria() {
            this._processCopyEmailCode("ometria");
        },

        _processCopyEmailCodeSFMC(userHTML) {
            this._processCopyEmailCode("sfmc", userHTML);
        },

        _processCopyEmailCodeDefault() {
            this._processCopyEmailCode();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/email/CopyEmailButtonView.js